import {useNavigate} from "react-router-dom";
import {useUpdateSession, Session} from "../../../../features/sessions";
import {EditSessionFormValues} from "../types";
import {message} from "antd";
import {editSessionDto} from "../edit-service-service";

interface HookResult {
  editSession(values: EditSessionFormValues): void;
  wasSessionEdited: boolean;
  isEditingSession: boolean;
  responseData?: Session;
}

/**
 * Hook for editing a session.
 * Uses useUpdateSession from features/sessions for the mutation.
 */
export function useEditService(): HookResult {
  const navigate = useNavigate();
  const editSessionMutation = useUpdateSession();

  const editSession = (values: EditSessionFormValues) => {
    editSessionMutation.mutate(editSessionDto(values), {
      onSuccess() {
        message.success("Updated Successfully");
        navigate("/calls");
      },
    });
  };

  return {
    editSession,
    wasSessionEdited: editSessionMutation.isSuccess,
    isEditingSession: editSessionMutation.isPending,
    responseData: editSessionMutation.isSuccess ? editSessionMutation.data : undefined,
  };
}
